// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { InternalTableHeaderCell } from './internal';
function TableHeaderCell(props) {
    const { __internalRootRef } = useBaseComponent('TableHeaderCell', {
        props: { disablePaddings: props.disablePaddings },
    });
    return React.createElement(InternalTableHeaderCell, { ...props, ref: __internalRootRef });
}
applyDisplayName(TableHeaderCell, 'TableHeaderCell');
export default TableHeaderCell;
//# sourceMappingURL=index.js.map